export var HOMEWORK_ASSIGNMENT_REPOSITORY = 'HOMEWORK_ASSIGNMENT_REPOSITORY';